// Cliente de la consola contra su propio origen (/api del gateway). La sesión es la de Supabase Auth, la misma de la
// aplicación del negocio; el negocio elegido viaja en un encabezado y el servidor lo vuelve a verificar siempre.
import { supabase } from './supabase';

export class ErrorApi extends Error {
  constructor(message: string, readonly estado: number, readonly detalles: string[] = []) { super(message); }
}

let cuentaActual: string | null = null;
export const fijarCuenta = (id: string | null) => { cuentaActual = id; };

export async function api<T = any>(ruta: string, cuerpo?: unknown): Promise<T> {
  const { data } = await supabase.auth.getSession();
  const r = await fetch(ruta, {
    method: cuerpo !== undefined ? 'POST' : 'GET',
    headers: {
      ...(data.session ? { authorization: `Bearer ${data.session.access_token}` } : {}),
      ...(cuentaActual ? { 'x-glubi-cuenta': cuentaActual } : {}),
      ...(cuerpo !== undefined ? { 'content-type': 'application/json' } : {}),
    },
    body: cuerpo !== undefined ? JSON.stringify(cuerpo) : undefined,
  });
  const texto = await r.text();
  let json: any = null;
  try { json = texto ? JSON.parse(texto) : null; } catch { /* no era JSON */ }
  if (!r.ok) throw new ErrorApi(json?.error?.message ?? json?.error ?? `Error ${r.status}`, r.status, json?.detalles ?? []);
  return json as T;
}

export function mensajeDeError(e: unknown): string {
  if (e instanceof ErrorApi) return e.detalles.length ? `${e.message}: ${e.detalles.join(' · ')}` : e.message;
  if (e instanceof TypeError) return 'Sin conexión con el gateway. Intentar de nuevo.';
  return e instanceof Error ? e.message : 'Algo falló. Intentar de nuevo.';
}
